var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticStyle:{"text-align":"center","margin-top":"20px"}},[_vm._v("Write your Solution")]),_vm._v(" "),_c('div',{staticClass:"ipad-complain"},[_c('canvas',{ref:"canvas",staticClass:"drawing-canvas",attrs:{"width":"800","height":"400"},on:{"touchstart":_vm.startDrawing,"touchmove":_vm.draw,"touchend":_vm.stopDrawing}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5b5b824","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/kneexpert/IpadComplain.vue
// module id = null
// module chunks = 